export const MuiListItemButtonTheme = (dt) => {
    return {
        defaultProps: {
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                paddingTop: dt.inset.squish.medium.variant.vertical,
                paddingBottom: dt.inset.squish.medium.variant.vertical,
                paddingLeft: 0,
                paddingRight: 0,
                columnGap: dt.inline.medium,
                "&:hover, &:is(.Pxl-demo-hover, [data-demostate=hover])": {
                    background: dt.cta.outlined.color.background.neutral.hover,
                },
                "&:active, &:is(.Pxl-demo-active, [data-demostate=active])": {
                    background: dt.cta.outlined.color.background.neutral.pressed,
                },
                "&:focus-visible, &:is(.Pxl-demo-focus, [data-demostate=focus])": {
                    background: dt.cta.outlined.color.background.neutral.focus,
                },
                "&.Mui-selected": {
                    background: dt.cta.outlined.color.background.primary.active,
                    "&:hover, &:is(.Pxl-demo-hover, [data-demostate=hover])": {
                        background: dt.cta.outlined.color.background.primary.hover,
                    },
                    "&:active, &:is(.Pxl-demo-active, [data-demostate=active])": {
                        background: dt.cta.outlined.color.background.primary.pressed,
                    },
                    "&:focus-visible, &:is(.Pxl-demo-focus, [data-demostate=focus])": {
                        background: dt.cta.outlined.color.background.primary.focus,
                    },
                    "&.Mui-disabled": {
                        background: dt.cta.contained.color.background.primary.disabled,
                    },
                },
            },
            alignItemsFlexStart: {},
            dense: {
                paddingTop: dt.stacked.xSmall,
                paddingBottom: dt.stacked.xSmall,
            },
            gutters: {
                paddingLeft: dt.inset.squish.medium.variant.horizontal,
                paddingRight: dt.inset.squish.medium.variant.horizontal,
            },
        },
    };
};
